import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseStoreService, BaseEntity } from './base-store.service';
import {apiUrl} from '../defines';
import {IdNameModel} from '../models/id.name.model';


@Injectable({
  providedIn: 'root'
})
export class BusBrandStore extends BaseStoreService<BaseEntity> {
  baseUrl = `${apiUrl}`;
  protected http = inject(HttpClient);
  protected apiUrl = `${this.baseUrl}/references/busBrands`;

  protected getEntityName(): string {
    return 'Marques de bus';
  }

}
